<div class="header-assignee main-app">
    <div class="avatar">
        <core-avatar-img *ngIf="user != null" [user]="user" [size]="40"></core-avatar-img>
        <!-- <p *ngIf="user == null">Fake avatar</p> -->
        <img class="empty-avatar" *ngIf="user == null"
            [ngStyle]="{ 'width.px': 80, 'height.px': 80 }"
            src="assets/fake_avatar.png"
            width="40"
            height="40"
            border="0"
            class=""
        />
        <!-- <core-avatar-img ></core-avatar-img> -->
    </div>
    <div class="assignee-info">
        <p>
            <span class="assignee-pre" [innerHTML]="preText">{{preText}}</span>
            <span class="assignee-name" *ngIf="user != null && !displayUsers" (click)="assigneeClick()" [title]="user.name" >{{user.name}}</span>
            <span class="assignee-select-item" *ngIf="user == null" title="select user..." (click)="assigneeClick()">select user</span>
        </p>
        <div class="user-assign-fake-combo-wrapper" *ngIf="displayUsers">
            <!-- <p *ngFor="let asignee of users">{{asignee.name}}</p> -->
            <div class="user-assign-fake-combo">
                <!--  This combo is for remove current assignee when set, alwasy should be shown -->
                <div class="user-assign-fake-combo-item remove-item" (click)="removeAsignee()" *ngIf="user != null">
                    <img class="empty-avatar"
                        [ngStyle]="{ 'width.px': 40, 'height.px': 40 }"
                        src="assets/fake_avatar.png"
                        width="40"
                        height="40"
                        border="0"
                        class=""
                    />
                    <span>Remove Current Asignee</span>
                </div>
                <div class="user-assign-overflow" *ngIf="options.length > 0">
                    <div class="user-assign-fake-combo-item" *ngFor="let u of options | usersSortByName: 'asc' ">
                        <core-helper-box-user-email
                            [user]="u"
                            (click)="userSelect(u)"
                        ></core-helper-box-user-email>
                    </div>
                </div>
            </div>
            <div class="user-assign-close" title="Close" (click)="cancel()">X</div>
        </div>

        <p [hidden]=""><span class="assignee-post-text" [innerHTML]="posText">{{posText}}</span></p>
    </div>
</div>
